import { useQuery } from "@tanstack/react-query";
import { api } from "services/src/config";
import { useLatestQuadrimester } from "components/quadrimester";

export const useBestPerformers = (
    filters = {},
    options = {},
    page = 1,
    limit = 20
) => {
    const { latestQuadrimesterId } = useLatestQuadrimester();

    const queryKey = ["get-top-performers", filters, latestQuadrimesterId, page];

    const queryFn = async () => {
        const params = {
            ...filters,
            quadrimester: filters.quadrimester || latestQuadrimesterId,
            limit,
            page,
        };

        const { data } = await api.get("get-top-performers", { params });
        return data;
    };

    return useQuery({
        queryKey,
        queryFn,
        enabled: !!latestQuadrimesterId,
        ...options,
    });
};
